const ActionBar = ({ children }) => {
  if (!children) return null;
  return (
    <div className="gap-2 flex-row bg-slate-100 p-2 border flex h-full justify-center items-center">
      {children}
    </div>
  );
};

export default ActionBar;
